import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';

import { areCredentialsExists } from '../storage/localStorage';
import { SIGN_IN_PATH, HOME_PATH, WELCOME_PATH } from '../constants/routes';
import { getAuthInfo, setLoading, logout } from '../store/actions/session';
import LoadingComponent from '../components/core/LoadingComponent/LoadingComponent';
import CookiePolicyBannerComponent from '../components/core/CookiePolicyBannerComponent/CookiePolicyBannerComponent';

class AuthRoute extends React.Component {
    componentWillMount() {
        const { setLoading, getAuthInfo } = this.props;

        if (areCredentialsExists()) {
            getAuthInfo();
        } else {
            setLoading(false);
        }
    }

    render() {
        const {
            component,
            path,
            isLoading,
            showCookiePolicyBanner,
            user: { uid },
        } = this.props;
        let root;

        if (!areCredentialsExists() && this.props.needAuth === undefined) {
            logout();
            root = SIGN_IN_PATH;
        } else if ([ HOME_PATH ].indexOf(path) > -1) {
            root = WELCOME_PATH;
            ReactGA.set({ userId: uid });
        }

        if (root !== undefined && root !== path) {
            return <Redirect to={root} />;
        }

        return <div className="content-wrap">
            {isLoading && <LoadingComponent fullScreen />}
            <Route {...this.props} component={component} />
            {showCookiePolicyBanner && <CookiePolicyBannerComponent />}
        </div>;
    };
}

AuthRoute.propTypes = {
    component: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
    ]),
    getAuthInfo: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    showCookiePolicyBanner: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    needAuth: PropTypes.bool,
};

const mapStateToProps = ({
    session: { user, isLoading, showCookiePolicyBanner },
}) => ({
    user,
    isLoading,
    showCookiePolicyBanner,
});

const mapDispatchToProps = {
    getAuthInfo,
    setLoading,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthRoute));



// WEBPACK FOOTER //
// ./src/routes/AuthRoute.js